import createIcon from '../../createIcon';

/**
 * @component @name FitScreen
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgNEgyMEMyMS4xIDQgMjIgNC45IDIyIDZWOEgyMFY2SDE3VjRaTTQgOFY2SDdWNEg0QzIuOSA0IDIgNC45IDIgNlY4SDRaTTIwIDE2VjE4SDE3VjIwSDIwQzIxLjEgMjAgMjIgMTkuMSAyMiAxOFYxNkgyMFpNNyAxOEg0VjE2SDJWMThDMiAxOS4xIDIuOSAyMCA0IDIwSDdWMThaTTE4IDhINlYxNkgxOFY4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FitScreen = createIcon('FitScreen', [
  [
    'path',
    {
      d: 'M17 4H20C21.1 4 22 4.9 22 6V8H20V6H17V4ZM4 8V6H7V4H4C2.9 4 2 4.9 2 6V8H4ZM20 16V18H17V20H20C21.1 20 22 19.1 22 18V16H20ZM7 18H4V16H2V18C2 19.1 2.9 20 4 20H7V18ZM18 8H6V16H18V8Z',
      key: 'tu87rb',
    },
  ],
]);

export default FitScreen;
